import { apiConstructor as api } from '@/api/apiConstructor';
import { Product, ProductState } from '@/types/product';
import { AxiosRequestConfig, AxiosResponse } from 'axios';

export async function getProducts(
  funder: string,
  page: number,
): Promise<ProductState> {
  const config: AxiosRequestConfig = {
    params: {
      funder,
      page,
    },
  };
  try {
    const response: AxiosResponse = await api.get('products', config);
    return response.data;
  } catch (error: any) {
    return error.data;
  }
}

export async function getProduct(id: string): Promise<Product> {
  try {
    const response: AxiosResponse = await api.get(`products/${id}`);
    return response.data;
  } catch (error: any) {
    return error.data;
  }
}

export async function saveProduct(product: Product): Promise<Product> {
  try {
    const response: AxiosResponse = await api.put(`products/${product.id}`, {
      ...product,
    });
    return response.data;
  } catch (error: any) {
    return error.data;
  }
}
